/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  /**
   * Check if we should enable Rebuy tracking based on URL/page conditions
   */
  function shouldEnableRebuyTracking() {
    const bodyId = document.body.id;
    const currentUrl = window.location.href.toLowerCase();
    const currentPath = window.location.pathname.toLowerCase();
    
    const isBundleUrl = currentUrl.includes('build-a-bundle-save-up-to-30-off') || 
                        currentPath.includes('build-a-bundle-save-up-to-30-off');
    
    const isBundleColorSelectPage = bodyId.includes('bundle-color-select') ||
                                    bodyId.includes('bundle-color') ||
                                    currentPath.includes('bundle-color-select') ||
                                    currentPath.includes('bundle-color');
    return isBundleUrl || isBundleColorSelectPage;
  }
  
  /**
   * Track Rebuy cart changes for Bundle Color Select template
   * Only runs if template matches or URL contains specific string
   */
  function initRebuyCartTracking() {
    function observeRebuyCart() {
      const rebuyCart = document.getElementById('rebuy-cart');
      if (!rebuyCart) {
        setTimeout(observeRebuyCart, 1000);
        return;
      }
      const cartItemsContainer = rebuyCart.querySelector('[data-rebuy-component="cart-items"]');
      if (!cartItemsContainer) {
        return;
      }
      function refreshThemeCartAndOpen() {
        // Use AJAX cart refresh instead of full page reload for faster cart update
        // The theme listens for 'theme:cart:refresh' → fetches updated cart section HTML
        // → updates DOM → dispatches 'theme:product:added' → cart drawer opens automatically
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        
        // Fallback: if the AJAX refresh doesn't work within 3 seconds, do a page reload
        var refreshFallback = setTimeout(function() {
          sessionStorage.setItem('rebuyCartRefresh', 'true');
          sessionStorage.setItem('rebuyCartRefreshTime', Date.now().toString());
          window.location.reload();
        }, 3000);
        
        // Cancel fallback if cart drawer opens successfully
        document.addEventListener('theme:product:added', function onAdded() {
          clearTimeout(refreshFallback);
          document.removeEventListener('theme:product:added', onAdded);
        });
      }
      
      let debounceTimer = null;
      let isInitialized = false;
      let pageReloadTimeout = null;
      
      // Function to set up page reload fallback (2 seconds after button click)
      function setupPageReloadFallback() {
        // Clear any existing timeout
        if (pageReloadTimeout) {
          clearTimeout(pageReloadTimeout);
        }
        
        pageReloadTimeout = setTimeout(function() {
          sessionStorage.setItem('rebuyCartRefresh', 'true');
          sessionStorage.setItem('rebuyCartRefreshTime', Date.now().toString());
          window.location.reload();
        }, 2000);
      }
      
      // Function to cancel page reload fallback (if MutationObserver succeeds)
      function cancelPageReloadFallback() {
        if (pageReloadTimeout) {
          clearTimeout(pageReloadTimeout);
          pageReloadTimeout = null;
        }
      }
      
      // Function to set up click listeners for rebuy-button elements
      function setupRebuyButtonListeners() {
        // Find the bundle builder container
        const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
        
        if (!bundleBuilderContainer) {
          // Container not found, try again later
          return;
        }
        
        // Find rebuy buttons only inside the bundle builder container
        const rebuyButtons = bundleBuilderContainer.querySelectorAll('.rebuy-button');
        
        rebuyButtons.forEach(function(button) {
          // Check if listener already added
          if (button.hasAttribute('data-rebuy-tracking-listener')) {
            return;
          }
          
          button.setAttribute('data-rebuy-tracking-listener', 'true');
          
          button.addEventListener('click', function(e) {
            // Set up page reload fallback after 2 seconds
            setupPageReloadFallback();
            
            // Note: MutationObserver will detect the change and cancel the reload
            // If MutationObserver fails, the page will reload after 2 seconds
          });
        });
      }
      
      // Set up initial listeners
      setupRebuyButtonListeners();
      
      // Watch for dynamically added rebuy buttons inside bundle builder container
      const rebuyButtonObserver = new MutationObserver(function(mutations) {
        let shouldCheck = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                // Check if the added node is inside bundle builder container
                const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
                if (!bundleBuilderContainer) {
                  return;
                }
                
                // Check if the added node is a rebuy button or contains one
                const isRebuyButton = node.classList && node.classList.contains('rebuy-button');
                const containsRebuyButton = node.querySelector && node.querySelector('.rebuy-button');
                const isInsideContainer = bundleBuilderContainer.contains(node);
                
                if ((isRebuyButton || containsRebuyButton) && isInsideContainer) {
                  shouldCheck = true;
                }
              }
            });
          }
        });
        
        if (shouldCheck) {
          setupRebuyButtonListeners();
        }
      });
      
      // Observe the bundle builder container for new rebuy buttons
      const bundleBuilderContainer = document.querySelector('.rebuy-bundle-builder__cta-container');
      if (bundleBuilderContainer) {
        rebuyButtonObserver.observe(bundleBuilderContainer, {
          childList: true,
          subtree: true
        });
      } else {
        // If container doesn't exist yet, observe body and check for container
        rebuyButtonObserver.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
      
      const observer = new MutationObserver(function(mutations) {
        if (!isInitialized) {
          isInitialized = true;
          return;
        }
        
        // Clear any existing timer
        if (debounceTimer) {
          clearTimeout(debounceTimer);
        }
        
        // Debounce to avoid multiple rapid refreshes
        debounceTimer = setTimeout(function() {
          // Cancel page reload fallback since MutationObserver detected the change
          cancelPageReloadFallback();
          
          refreshThemeCartAndOpen();
        }, 100);
      });
      
      observer.observe(cartItemsContainer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeOldValue: true
      });
      
    }
    
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeRebuyCart);
    } else {
      observeRebuyCart();
    }
  }
  
  /**
   * Remove Rebuy injected style element and body classes
   * Watches for style#smart-cart-style and removes it when it appears
   * Also removes Rebuy visibility classes from body
   */
  function removeRebuyInjectedStyle() {
    function checkAndRemoveStyle() {
      const smartCartStyle = document.getElementById('smart-cart-style');
      
      if (smartCartStyle) {
        smartCartStyle.remove();
        return true;
      }
      
      return false;
    }
    
    checkAndRemoveStyle();
    
    const styleObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.id === 'smart-cart-style') {
                checkAndRemoveStyle();
                return;
              }
              
              const nestedStyle = node.querySelector ? node.querySelector('#smart-cart-style') : null;
              if (nestedStyle) {
                checkAndRemoveStyle();
              }
            }
          });
        }
      });
    });
    
    // Only observe <head> where style elements belong — avoids costly body-wide DOM observation
    if (document.head) {
      styleObserver.observe(document.head, {
        childList: true,
        subtree: true
      });
    }
    
    function removeRebuyBodyClasses() {
      const rebuyClasses = [
        'rebuy-modal-visible',
        'rebuy-cart-visible',
        'rebuy-bundle-builder-container-visible'
      ];
      
      let removedAny = false;
      rebuyClasses.forEach(function(className) {
        if (document.body.classList.contains(className)) {
          document.body.classList.remove(className);
          removedAny = true;
        }
      });
      
      return removedAny;
    }
    
    removeRebuyBodyClasses();
    
    const bodyClassObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          removeRebuyBodyClasses();
        }
      });
    });
    
    if (document.body) {
      bodyClassObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }
    
  }
  
  /**
   * Check if page was reloaded due to cart add
   * Returns true if sessionStorage indicates a cart refresh occurred
   */
  function wasReloadedFromCartAdd() {
    const refreshFlag = sessionStorage.getItem('rebuyCartRefresh');
    if (refreshFlag === 'true') {
      // Clear the flag so it doesn't trigger on subsequent reloads
      sessionStorage.removeItem('rebuyCartRefresh');
      const refreshTime = sessionStorage.getItem('rebuyCartRefreshTime');
      sessionStorage.removeItem('rebuyCartRefreshTime');
      return {
        wasReloaded: true,
        timestamp: refreshTime ? parseInt(refreshTime, 10) : null
      };
    }
    return { wasReloaded: false, timestamp: null };
  }
  
  /**
   * Open cart drawer after page load
   */
  function openCartDrawerOnLoad() {
    function attemptOpen() {
      const cartDrawer = document.querySelector('cart-drawer') || document.getElementById('cart-drawer');
      
      if (cartDrawer) {
        if (typeof cartDrawer.openCartDrawer === 'function') {
          cartDrawer.openCartDrawer();
        } else {
          document.dispatchEvent(new CustomEvent('theme:cart-drawer:show', { bubbles: true }));
        }
        return true;
      }
      return false;
    }
    
    // Try immediately
    if (attemptOpen()) {
      return;
    }
    
    // If not found, wait for DOM and try again
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(attemptOpen, 500);
      });
    } else {
      setTimeout(attemptOpen, 500);
    }
  }
  
  /**
   * Initialize Rebuy tracking and style removal if conditions are met
   */
  function initRebuyFeatures() {
    // Always remove Rebuy injected Smart Cart style on all pages
    // Uses efficient MutationObserver — no polling
    removeRebuyInjectedStyle();

    // Check if page was reloaded due to cart add
    const reloadInfo = wasReloadedFromCartAdd();
    if (reloadInfo.wasReloaded) {
      // Page was reloaded from cart add - open cart drawer
      openCartDrawerOnLoad();
    }
    
    // Only initialize cart tracking on bundle pages (URL/body ID match)
    // No more 30-second DOM polling on every page
    if (shouldEnableRebuyTracking()) {
      initRebuyCartTracking();
    }
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRebuyFeatures);
  } else {
    initRebuyFeatures();
  }
})();